import * as ng from 'angular';
import { ArchiSmallServices } from './archismall.service';
import { BaseUrlService } from './base-url.service';
import { HttpResponseErrorInterceptorService } from './http-response-error-interceptor/http-response-error-interceptor.module';
import { RegisterUserService } from './register-user.service';
import { ValidationService } from './validation.service';
import { StoreService } from './store.service';
import { UserService } from './user.service';
import { UISelectService } from './ui-select.service';
import { StorageService } from './storage.service';
import { RubricaService } from './rubrica.service';
import { PreviewService } from './preview.service';
import { GoogleDriveService } from './google-drive.service';
import { FatturaElettronicaPassivaService } from './fattura-elettronica-passiva.service';
import { DropboxService } from './dropbox.service';
import { DropboxSaverService } from './dropbox-saver.service';
import { CheckBrowserPluginsService } from './check-browser-plugins.service';
import { CodiceDestinatarioService } from './codice-destinatario.service';
import { ConservazioneService } from './conservazione.service';
import { ContractService } from './contract.service';
import { GetWatchCountService } from './get-watch-count.service';
import { DateService } from './date.service';
import { FileService } from './file.service';
import { LogoService } from './logo.service';
import { CassaService } from './data/cassa.service';
import { CountryCodesService } from './data/country-codes.service';
import { ModalitaPagamentoService } from './data/modalita-pagamento.service';
import { VATService } from './data/vat.service';
import { AlertService } from './ui/alert.service';
import { FormService } from './ui/form.service';
import { NumbersService } from './ui/numbers.service';

const ServicesModule: string = ng
    .module('ServicesModule', [
        HttpResponseErrorInterceptorService
    ])
    .service('ArchiSmallServices', ArchiSmallServices)
    .service('BaseUrlService', BaseUrlService)
    .service('RegisterUserService', RegisterUserService)
    .service('ValidationService', ValidationService)
    .service('StoreService', StoreService)
    .service('UserService', UserService)
    .service('UiSelectService', UISelectService)
    .service('StorageService', StorageService)
    .service('RubricaService', RubricaService)
    .service('PreviewService', PreviewService)
    .service('GoogleDriveService', GoogleDriveService)
    .service('FatturaElettronicaPassivaService', FatturaElettronicaPassivaService)
    .service('DropboxService', DropboxService)
    .service('DropboxSaverService', DropboxSaverService)
    .service('CheckBrowserPluginsService', CheckBrowserPluginsService)
    .service('CodiceDestinatarioService', CodiceDestinatarioService)
    .service('ConservazioneService', ConservazioneService)
    .service('ContractService', ContractService)
    .service('GetWatchCountService', GetWatchCountService)
    .service('DateService', DateService)
    .service('FileService', FileService)
    .service('LogoService', LogoService)
    .service('CassaService', CassaService)
    .service('CountryCodesService', CountryCodesService)
    .service('ModalitaPagamentoService', ModalitaPagamentoService)
    .service('VATService', VATService)
    .service('AlertService', AlertService)
    .service('FormService', FormService)
    .service('NumbersService', NumbersService)
    .name;


export { ServicesModule };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/services.module.ts